module.exports = __webpack_public_path__ + "static/img/top2.5d16cb8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/top2.png
// module id = fGDL
// module chunks = 23